import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export const FullContainer = (props) =>
    <Container fluid className='container-main'>
        <Row>
            <Col md={{ span: 12 }}>
                { props.children }
            </Col>
        </Row>
    </Container>

export const WideContainer = (props) =>
    <Container fluid className='container-main'>
        <Row>
            <Col md={{ span: 10, offset: 1 }}>
                { props.children }
            </Col>
        </Row>
    </Container>

export const MediumContainer = (props) =>
    <Container fluid className='container-main'>
        <Row>
            <Col md={12} lg={{ span: 8, offset: 2 }}>
                { props.children }
            </Col>
        </Row>
    </Container>

export const NarrowContainer = (props) =>
    <Container fluid className='container-main'>
        <Row>
            <Col md={{ span: 6, offset: 3 }}>
                { props.children }
            </Col>
        </Row>
    </Container>